module.exports = __webpack_public_path__ + "static/img/hero-dashboard.d5ece06.png";


//////////////////
// WEBPACK FOOTER
// ./LandingPageTemp/Assets/hero-dashboard.png
// module id = ZSFl
// module chunks = 1